module.exports = __webpack_public_path__ + "static/pavel-durov-448cda077ee15d2de2e5031791150a44.jpg";